var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_21674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3467 12.8301L16.8453 58.6518L2.14755 43.954C-0.0317311 41.7747 -0.616416 38.4627 0.688586 35.6694L11.3467 12.8301Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0911 2.41755C41.5423 0.868779 39.4437 0 37.2552 0C35.8898 0 34.5444 0.339081 33.3421 0.986083L11.3477 12.8301V50.1161C11.3477 52.0608 12.1193 53.9248 13.4958 55.2995L16.8463 58.6518H57.1693V49.4874L69.9994 29.3259L43.0911 2.41755Z",
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 12.8301H50.4666C52.4112 12.8301 54.2753 13.6017 55.6499 14.9782L69.9994 29.3259V58.6518H57.1693L11.3477 12.8301Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1707 58.6523H16.8477L27.8449 69.6495H57.1707V58.6523Z",
    fill: "#85CBF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_21674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.2433ed92d751a701eebcb0113c821b55.svg";
export { ForwardRef as ReactComponent };